import storage from "./utils/storage";
import Vue from "vue";
import ElementUI from "element-ui";
import "@/assets/styles/element-variables.scss";
// import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import store from "./store";
import plugins from "./plugins";
import { parseTime, resetForm } from "./utils";

Vue.prototype.parseTime = parseTime;
Vue.prototype.resetForm = resetForm;
Vue.prototype.storage = storage;
Vue.use(plugins);
Vue.use(ElementUI);
Vue.config.productionTip = false;



new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount("#app");
